
































import { Component, Vue, Prop } from 'vue-property-decorator'
import InputMoney from './InputMoney.vue'
import InputNumber from './InputNumber.vue'
import InputPercentage from './InputPercentage.vue'
import InputSelect, { SelectItem } from './InputSelect.vue'
import InputText from './InputText.vue'
import { normalize } from '@/utils/CommonUtils'

@Component({
  components: {
    InputMoney,
    InputNumber,
    InputPercentage,
    InputSelect,
    InputText,
  }
})
export default class InputGeneric extends Vue {
  @Prop(String) readonly id?: string
  @Prop() readonly value!: string | number
  @Prop({ default: '' }) readonly label!: string
  @Prop({ default: false }) readonly hideLabel!: boolean | string
  @Prop({ default: false }) readonly labelRight!: boolean | string
  @Prop(String) readonly inputType!: string
  @Prop({ default: () => ([]) }) readonly items!: Array<SelectItem>
  @Prop({ default: () => ([]) }) readonly errors!: Array<string>
  @Prop({ default: 'end' }) readonly alignment!: string

  get isLabelRight () { return this.labelRight === true || this.labelRight === '' }
  get isHideLabel () { return this.hideLabel === true || this.hideLabel === '' }

  get computedId () {
    if (this.id !== undefined) {
      return this.id
    } else {
      return normalize(this.label).replaceAll(' ', '_')
    }
  }

  get inputComponent () {
    switch (this.inputType) {
      case 'money':
        return 'InputMoney'
      case 'number':
        return 'InputNumber'
      case 'percentage':
        return 'InputPercentage'
      case 'select':
        return 'InputSelect'
      case 'text':
        return 'InputText'
      default:
        return 'InputText'
    }
  }
}
